module.exports = __webpack_public_path__ + "img/cc.51e45c7f.png";